import React from "react";
import { Tooltip } from "antd";
import InfoIcon from "../../../assets/Info_Icon.svg";
import { simpleKFormatterOnly } from "../../../redux/constants";

const AgentNewTicket = ({ totalsTicketwidget }) => {
  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <div className="portlet1 border-radius-4 d-flex">
          <div className="w-100 border-right border-color text-center">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data && totalsTicketwidget?.data[0]?.text}
              <Tooltip
                title="These are the new tickets created in the selected month"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
                {/* <i className="fa fa-question-circle ml-1" /> */}
              </Tooltip>
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={
                  totalsTicketwidget?.data && totalsTicketwidget?.data[0]?.value
                    ? totalsTicketwidget?.data[0]?.value?.toLocaleString()
                    : "0"
                }
                placement="bottom"
              >
                {totalsTicketwidget?.data && totalsTicketwidget?.data[0]?.value
                  ? simpleKFormatterOnly(totalsTicketwidget?.data[0]?.value)
                  : "0"}
              </Tooltip>
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  totalsTicketwidget?.data &&
                  totalsTicketwidget?.data[0]?.percent_change > 0
                    ? "positive"
                    : "error"
                }`}
              >
                {totalsTicketwidget?.data &&
                  totalsTicketwidget?.data[0]?.percent_change}
                %
                <i
                  className={`fa ml-1 ${
                    totalsTicketwidget?.data &&
                    totalsTicketwidget?.data[0]?.percent_change > 0
                      ? "fa-caret-up"
                      : "fa-caret-down"
                  }`}
                />
              </span>
            </div>
          </div>
          <div className="w-100 pl-15 text-center">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data && totalsTicketwidget?.data[1]?.text}
              <Tooltip
                title="These are the mentions associated with new tickets created in the selected month"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
                {/* <i className="fa fa-question-circle ml-1" /> */}
              </Tooltip>
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={
                  totalsTicketwidget?.data &&
                  totalsTicketwidget?.data?.[1]?.value?.toLocaleString()
                }
                placement="bottom"
              >
                {simpleKFormatterOnly(
                  totalsTicketwidget?.data &&
                    totalsTicketwidget?.data?.[1]?.value
                )}
              </Tooltip>
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  totalsTicketwidget?.data &&
                  totalsTicketwidget?.data[1]?.percent_change > 0
                    ? "positive"
                    : "error"
                }`}
              >
                {totalsTicketwidget?.data &&
                  totalsTicketwidget?.data[1]?.percent_change}
                %
                <i
                  className={`fa ml-1 ${
                    totalsTicketwidget?.data &&
                    totalsTicketwidget?.data[1]?.percent_change > 0
                      ? "fa-caret-up"
                      : "fa-caret-down"
                  }`}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 pl-0">
        <div className="d-flex">
          <div className="portlet1 border-radius-4 text-center w-100 mr-15">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data[2]?.text}
              <Tooltip
                title="These are the total number of tickets which are either pending or closed in the selected month"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
                {/* <i className="fa fa-question-circle ml-1" /> */}
              </Tooltip>
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={
                  totalsTicketwidget?.data[2]?.value
                    ? totalsTicketwidget?.data[2]?.value?.toLocaleString()
                    : "0"
                }
                placement="bottom"
              >
                {totalsTicketwidget?.data[2]?.value
                  ? simpleKFormatterOnly(totalsTicketwidget?.data[2]?.value)
                  : "0"}
              </Tooltip>
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  totalsTicketwidget?.data[2]?.percent_change > 0
                    ? "positive"
                    : "error"
                }`}
              >
                {totalsTicketwidget?.data[2]?.percent_change
                  ? totalsTicketwidget?.data[2]?.percent_change
                  : "0"}
                %
                <i
                  className={`fa ml-1 ${
                    totalsTicketwidget?.data[2]?.percent_change > 0
                      ? "fa-caret-up"
                      : "fa-caret-down"
                  }`}
                />
              </span>
            </div>
          </div>
          <div className="portlet1 border-radius-4 text-center w-100">
            <div className="wm-chart-card-title">
              {totalsTicketwidget?.data[3]?.text}
              {/* <Tooltip
								title="This count show the number of tickets created in the selected duration."
								placement="bottom"
							>
								<i className="fa fa-question-circle ml-1" />
							</Tooltip> */}
            </div>
            <div className="wm-chart-card-value">
              <Tooltip
                title={
                  totalsTicketwidget?.data[3]?.value
                    ? totalsTicketwidget?.data[3]?.value?.toLocaleString()
                    : "0"
                }
                placement="bottom"
              >
                {totalsTicketwidget?.data[3]?.value
                  ? simpleKFormatterOnly(totalsTicketwidget?.data[3]?.value)
                  : "0"}
              </Tooltip>
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  totalsTicketwidget?.data[3]?.percent_change > 0
                    ? "positive"
                    : "error"
                }`}
              >
                {totalsTicketwidget?.data[3]?.percent_change
                  ? totalsTicketwidget?.data[3]?.percent_change
                  : "0"}
                %
                <i
                  className={`fa ml-1 ${
                    totalsTicketwidget?.data[3]?.percent_change > 0
                      ? "fa-caret-up"
                      : "fa-caret-down"
                  }`}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentNewTicket;
